import { Component, Input, OnDestroy } from '@angular/core';
import { AddToPlaylistDialogComponent } from '../';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ConfirmDialogComponent } from '../.././shared/'
import {AuthService} from '../../api/';
import { Router } from '@angular/router';

@Component({
  selector: 'add-to-playlist',
  templateUrl: './add-to-playlist.component.html',
  styleUrls: ['./add-to-playlist.component.css']
})

export class AddToPlaylistComponent implements OnDestroy {
  @Input() song: any;
  @Input() playlist: any;
  @Input() aboveTooltip: string = 'below';
  dialogRef: MdDialogRef<AddToPlaylistDialogComponent>;
  dialogRef1: MdDialogRef<ConfirmDialogComponent>;
  @BlockUI() blockUI: NgBlockUI;
  constructor(public dialog: MdDialog,public authService: AuthService, private router: Router) {
  }

  addToPlaylist(event) {
    event.stopPropagation();
    event.preventDefault();

    if(!this.authService.isUserLoggedIn()){
        this.router.navigate(['/login']);
    }
      if(this.authService.isUserLoggedIn()) {
          if (this.song) {
              if(window.outerWidth < 1024){
                  this.dialogRef = this.dialog.open(AddToPlaylistDialogComponent, {
                      disableClose: true,
                      height: '400px',
                      width: '600px',
                  });
                  this.dialogRef.componentInstance.song = this.song;
              }else {
              this.dialogRef = this.dialog.open(AddToPlaylistDialogComponent, {
                  disableClose: true,
                  height: '600px',
                  width: '800px',
              });
              this.dialogRef.componentInstance.song = this.song;
              }
              }
          else if (this.playlist) {


              this.dialogRef1 = this.dialog.open(ConfirmDialogComponent, {
                  disableClose: false,
              });
              this.dialogRef1.componentInstance.message = "Are you sure that you want to add the entire playlist to another playlist?";
              this.dialogRef1.afterClosed().subscribe(result => {
                  if (result && result === true) {

                      this.blockUI.start('Loading, please wait...');
                      if (this.playlist) {
                          if(window.outerWidth < 1024){
                              this.dialogRef = this.dialog.open(AddToPlaylistDialogComponent, {
                                  disableClose: true,
                                  height: '400px',
                                  width: '800px',
                              });
                          } else {
                              this.dialogRef = this.dialog.open(AddToPlaylistDialogComponent, {
                                  disableClose: true,
                                  height: '600px',
                                  width: '800px',
                              });
                          }
                          this.dialogRef.componentInstance.playlist1 = this.playlist;
                      }
                      this.blockUI.stop();
                      return false;
                  }
              });
          }
      }
  }


  ngOnDestroy() {

  }

}



// WEBPACK FOOTER //
// ./src/app/songs/add-to-playlist/add-to-playlist.component.ts